module.exports = function() {
  return new Worker(__webpack_public_path__ + "9135d970a9c2b0dbf8c3.worker.js");
};